import type { PlacedScore } from 'connectivity/beelday-client'
import type { PlayerRanking } from './types'

export type Medal = 1 | 2 | 3

/**
 * The medal a player earned, if any. Places are dense - a 2-player quiz with
 * one right answer has a second place on 0 points - so the place alone would
 * hand silver or bronze to someone who answered nothing right.
 */
export const medalFor = ({
	place,
	score,
}: Pick<PlayerRanking, 'place' | 'score'>): Medal | undefined =>
	score > 0 && (place === 1 || place === 2 || place === 3) ? place : undefined

/** A podium step stands empty rather than carry players on 0 points. */
export const onPodium = (place: PlacedScore): PlacedScore =>
	place.score > 0 ? place : { ...place, players: [] }
